/** Handles validation logic for the task form using Zod. */
import { useState, useCallback } from 'react';
import { validateTaskForm } from '@/features/tasks/utils/ui/taskFormUtils';

export const useTaskFormValidation = (task) => {
  const [errors, setErrors] = useState({});

  const validate = useCallback(() => {
    const result = validateTaskForm(task);
    if (!result.success) {
      setErrors(result.errors);
      return false;
    }
    setErrors({});
    return true;
  }, [task]);

  return { errors, setErrors, validate };
};
